// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Mint from 'mint-ui';
import VueClipboard from 'vue-clipboard2'
import 'mint-ui/lib/style.css'
Vue.use(Mint);
Vue.use(VueClipboard);
// 按需引入部分组
import App from './App'
import { getStore, setStore } from './config/mUtils'
import router from './router/index'
import '../src/assets/css/normalize.css';
import '../src/assets/css/typo.css';
import '../src/assets/css/wapSlide.css';
import '../src/assets/new/css/style.css';
import { isOnlyWxLogin } from "./service/my";
import VueResource from 'vue-resource';
import { TITLE_TEXT } from "../src/config/language";
import ba from 'vue-ba'
Vue.config.productionTip = false;
Vue.use(ba, "db3633e1d724f51f2901304b88d5fab9");
Vue.use(ba, { siteId: "db3633e1d724f51f2901304b88d5fab9" }); /* eslint-disable no-new */

Vue.use(VueResource);
import Clipboard from 'clipboard';
Vue.prototype.Clipboard = Clipboard;
import VueQriously from 'vue-qriously'
// import $ from 'jquery'
Vue.use(VueQriously)
Vue.config.productionTip = false

const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)
//判断授权
router.beforeEach((to, from, next) => {
  //判断是否只能在微信打开
  isOnlyWxLogin(this).then(res => {
    if (res.errorNo = "0" && res.data == "1"&&to.fullPath.indexOf("errorpage") == -1) {
      next({
        path: '/errorpage',
      })
    } else{

      //除去微信 另一种隐藏头部的情况 只要hh有值 store有hh就全部隐藏头部
      let query = to.query;
      var hh = query.hh;
      if (hh) {
        setStore("hh", hh);
      }
      //如果是shop的页面 根据自身页面逻辑判断
      if (to.meta.title && to.meta.title != "Shop") {
        var title = to.meta.title;
        document.title = TITLE_TEXT.TEXT[title];
      }
      //是否初次 初次进引导页
      if (to.meta.title == "Login" && !getStore("notfirst")) {
        next({
          path: '/lead',
        })
      }

      if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
        let token = getStore("token");
        let timeOut = getStore("timeOut");
        let agent = JSON.parse(getStore("agent"));
        if (token) { // 判断当前的token是否存在 ； 登录存入的token
          let currentTime = new Date().getTime();
          if ((parseFloat(timeOut) * 1000) - currentTime > 0) {
            if (agent.del_flag == "2" && to.fullPath.indexOf("addbrandstep1") == -1 && to.fullPath.indexOf("index") == -1 && to.fullPath.indexOf("addbrandstep2") == -1 && to.fullPath.indexOf("addbrandstep3") == -1
              && to.fullPath.indexOf("addbrandstep4") == -1 && to.fullPath.indexOf("myHome") == -1 && to.fullPath.indexOf("setUp") == -1 && to.fullPath.indexOf("updatepwd") == -1) {
              next({
                path: '/addbrandstep1',
                query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
              })
            } else {
              next();
            }
          } else {
            next({
              path: '/login',
              query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
          }
        } else {
          next({
            path: '/login',
            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
          })
        }

      } else {
        next();
      }
    }
  });
  /* 路由发生变化修改页面title */
});

//  router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   const targetPath = router.history.pending.fullPath;
//   if (isChunkLoadFailed) {
//     router.replace(targetPath);
//   }
//  });

router.onError((err) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  console.log("发生chunk错误");
  const isChunkLoadFailed = err.message.match(pattern);
  if (isChunkLoadFailed) {
    let chunkBool = sessionStorage.getItem('chunkError');
    let nowTimes = Date.now();
    if (chunkBool === null || chunkBool && nowTimes - parseInt(chunkBool) > 60000) {//路由跳轉報錯,href手動跳轉
      sessionStorage.setItem('chunkError', 'reload');
      const targetPath = routers.history.pending.fullPath;
      window.location.href = window.location.origin + targetPath;
    } else if (chunkBool === 'reload') { //手動跳轉後依然報錯,強制刷新
      sessionStorage.setItem('chunkError', Date.now());
      window.location.reload(true);
    }
  }
})

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js